/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import e from "../../request.js";
import "../../core/has.js";
import { strict as s } from "../../core/jsonMap.js";
import { createAbortError as r } from "../../core/promiseUtils.js";
import { property as o } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import "../../core/arrayUtils.js";
import { enumeration as i } from "../../core/accessorSupport/decorators/enumeration.js";
import { subclass as a } from "../../core/accessorSupport/decorators/subclass.js";
import c from "../../rest/networks/support/ValidateNetworkTopologyResult.js";
const n = s()({
  Pending: "job-waiting",
  InProgress: "job-executing",
  Completed: "job-succeeded"
});
let l = class extends c {
  constructor(t) {
    super(t), this.statusUrl = null, this.status = null, this.submissionTime = null, this.lastUpdatedTime = null, this._timer = void 0;
  }
  destroy() {
    clearInterval(this._timer);
  }
  async checkJobStatus(t) {
    const s = {
        ...t,
        query: {
          f: "json"
        }
      },
      {
        data: r
      } = await e(this.statusUrl, s);
    return this.read(r), this.editsResolver && this.editsResolver.resolve({
      edits: null,
      addedFeatures: [],
      updatedFeatures: [],
      deletedFeatures: [],
      addedAttachments: [],
      updatedAttachments: [],
      deletedAttachments: [],
      exceededTransferLimit: !0,
      historicMoment: null
    }), this;
  }
  async waitForJobCompletion(t = {}) {
    const {
      interval: e = 1e3,
      statusCallback: s
    } = t;
    return new Promise((t, o) => {
      this._clearTimer();
      const i = setInterval(() => {
        this._timer || o(r()), this.checkJobStatus().then(e => {
          const {
            status: r
          } = e;
          switch (this.status = r, r) {
            case "job-succeeded":
              this._clearTimer(), t(this);
              break;
            case "job-waiting":
            case "job-executing":
              s && s(this);
          }
        }, t => {
          this._clearTimer(), o(t);
        });
      }, e);
      this._timer = i;
    });
  }
  _clearTimer() {
    clearInterval(this._timer), this._timer = void 0;
  }
};
t([o()], l.prototype, "editsResolver", void 0), t([o({
  type: String,
  json: {
    write: !0
  }
})], l.prototype, "statusUrl", void 0), t([i(n)], l.prototype, "status", void 0), t([o({
  type: Date,
  json: {
    type: Number,
    write: {
      writer: (t, e) => {
        e.submissionTime = t ? t.getTime() : null;
      }
    }
  }
})], l.prototype, "submissionTime", void 0), t([o({
  type: Date,
  json: {
    type: Number,
    write: {
      writer: (t, e) => {
        e.lastUpdatedTime = t ? t.getTime() : null;
      }
    }
  }
})], l.prototype, "lastUpdatedTime", void 0), l = t([a("esri.networks.support.TopologyValidationJobInfo")], l);
const p = l;
export { p as default };